import { http } from 'helpers/http';

const URL = process.env.REACT_APP_API;
const listJobDesc = 'jobdesc/list';
const listJobVersionID = 'jobdesc/list-version';
const showJobDescDetail = 'jobdesc/view';
const hrApproval = 'jobdesc/hr-approval';
const detailJobDescV2 = 'jobdesc/view-v2';
const orgStructureJobDesc = 'jobdesc/view-structure-organization';
const mainRespoJobDesc = 'jobdesc/view-main-responsibility';
const KPIJobDesc = 'jobdesc/view-kpi';
const authorityJobDesc = 'jobdesc/view-authority';
const workingRelationshipJobDesc = 'jobdesc/view-working-relationship';
export const getListJobDesc = async (val) => {
  const datas = await http.post(`${URL + listJobDesc}`, val);
  return datas.data.data;
};
export const getListVersionID = async (val) => {
  const datas = await http.post(`${URL + listJobVersionID}`, val);
  return datas.data.data;
};
export const getShowJobDescDetail = async (val) => {
  const datas = await http.post(`${URL + showJobDescDetail}`, val);
  return datas.data.data;
};
export const postHrApprove = async (val) => {
  const datas = await http.post(`${URL + hrApproval}`, val);
  return datas.data;
};
export const apiDetailJobDescV2 = async (val) => {
  const datas = await http.post(`${URL + detailJobDescV2}`, val);
  return datas.data;
};
export const apiOrgStructureJobDesc = async (val) => {
  const datas = await http.post(`${URL + orgStructureJobDesc}`, val);
  return datas.data;
};
export const apiMainRespoJobDesc = async (val) => {
  const datas = await http.post(`${URL + mainRespoJobDesc}`, val);
  return datas.data;
};
export const apiKPIJobdesc = async (val) => {
  const datas = await http.post(`${URL + KPIJobDesc}`, val);
  return datas.data;
};
export const apiAuthorityJobDesc = async (val) => {
  const datas = await http.post(`${URL + authorityJobDesc}`, val);
  return datas.data;
};
export const apiWorkingRelationShipJobDesc = async (val) => {
  const datas = await http.post(`${URL + workingRelationshipJobDesc}`, val);
  return datas.data;
};
